import React, { useState, useCallback } from 'react';
import { RestAddress } from '../../../hooks/useAddress';
import { Box } from '../../Box';
import { AmazonShippingAndPaymentPreview } from '../AmazonShippingAndPaymentPreview';
import { AmazonShippingAndPaymentForm } from '../AmazonShippingAndPaymentForm';

type Props = {
  theme?: 'box' | 'simple';
  address?: RestAddress;
  addressId?: number | null;
  isFilled: boolean;
  readOnly?: boolean;
  onSwitchToAdyen: () => Promise<void>;
  onSubmit?: () => Promise<void>;
};

enum Mode {
  Resting,
  Editing
}

export const AmazonShippingAndPayment: React.FC<Props> = ({
  theme = 'simple',
  address,
  addressId,
  isFilled,
  readOnly,
  onSwitchToAdyen,
  onSubmit
}) => {
  const [mode, setMode] = useState(isFilled || readOnly ? Mode.Resting : Mode.Editing);

  const handleCancel = useCallback(() => (isFilled ? setMode(Mode.Resting) : onSwitchToAdyen()), [
    isFilled,
    onSwitchToAdyen
  ]);

  return (
    <Box borderless={theme === 'simple' || mode === Mode.Editing}>
      {mode === Mode.Resting && (
        <AmazonShippingAndPaymentPreview
          address={address}
          addressId={addressId}
          readOnly={readOnly}
          onEdit={() => setMode(Mode.Editing)}
          onSwitchToAdyen={onSwitchToAdyen}
        />
      )}
      {mode === Mode.Editing && (
        <AmazonShippingAndPaymentForm
          onClose={() => setMode(Mode.Resting)}
          onCancel={handleCancel}
          onSubmit={onSubmit}
        />
      )}
    </Box>
  );
};
